import { action } from '@reatom/framework'

import { Data, type Result } from '@blade/std-lib'

import type { Network } from '@root/entities/network'
import type { WalletAddress } from '@root/entities/wallet'

export class QrFlowNotValidAddressError extends Data.TaggedError(
  'QrFlowNotValidAddressError',
)<{
  address: string
  network: Network.Network
}> {}

// eslint-disable-next-line @reatom/unit-naming-rule
export const startScanQrFlowEvent = action<{
  onScanned: (
    address: Result.Result<WalletAddress, QrFlowNotValidAddressError>,
  ) => void
}>('startScanQrFlowEvent')
